// source: acompanha/notification/v1/notification.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
goog.exportSymbol('proto.acompanha.notification.v1.AckEvent', null, global);
goog.exportSymbol('proto.acompanha.notification.v1.JobIntegrationAction', null, global);
goog.exportSymbol('proto.acompanha.notification.v1.JobIntegrationChangedEvent', null, global);
goog.exportSymbol('proto.acompanha.notification.v1.Notification', null, global);
goog.exportSymbol('proto.acompanha.notification.v1.Notification.EventCase', null, global);
goog.exportSymbol('proto.acompanha.notification.v1.PingPongEvent', null, global);
goog.exportSymbol('proto.acompanha.notification.v1.SubscribeNotificationRequest', null, global);
goog.exportSymbol('proto.acompanha.notification.v1.SubscribeNotificationResponse', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.notification.v1.SubscribeNotificationRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.notification.v1.SubscribeNotificationRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.notification.v1.SubscribeNotificationRequest.displayName = 'proto.acompanha.notification.v1.SubscribeNotificationRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.notification.v1.SubscribeNotificationResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.notification.v1.SubscribeNotificationResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.notification.v1.SubscribeNotificationResponse.displayName = 'proto.acompanha.notification.v1.SubscribeNotificationResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.notification.v1.Notification = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.acompanha.notification.v1.Notification.oneofGroups_);
};
goog.inherits(proto.acompanha.notification.v1.Notification, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.notification.v1.Notification.displayName = 'proto.acompanha.notification.v1.Notification';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.notification.v1.AckEvent = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.notification.v1.AckEvent, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.notification.v1.AckEvent.displayName = 'proto.acompanha.notification.v1.AckEvent';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.notification.v1.PingPongEvent = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.notification.v1.PingPongEvent, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.notification.v1.PingPongEvent.displayName = 'proto.acompanha.notification.v1.PingPongEvent';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.notification.v1.JobIntegrationChangedEvent = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.notification.v1.JobIntegrationChangedEvent, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.notification.v1.JobIntegrationChangedEvent.displayName = 'proto.acompanha.notification.v1.JobIntegrationChangedEvent';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.notification.v1.SubscribeNotificationRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.notification.v1.SubscribeNotificationRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.notification.v1.SubscribeNotificationRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.notification.v1.SubscribeNotificationRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.notification.v1.SubscribeNotificationRequest}
 */
proto.acompanha.notification.v1.SubscribeNotificationRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.notification.v1.SubscribeNotificationRequest;
  return proto.acompanha.notification.v1.SubscribeNotificationRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.notification.v1.SubscribeNotificationRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.notification.v1.SubscribeNotificationRequest}
 */
proto.acompanha.notification.v1.SubscribeNotificationRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.notification.v1.SubscribeNotificationRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.notification.v1.SubscribeNotificationRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.notification.v1.SubscribeNotificationRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.notification.v1.SubscribeNotificationRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.acompanha.notification.v1.SubscribeNotificationRequest.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.notification.v1.SubscribeNotificationRequest} returns this
 */
proto.acompanha.notification.v1.SubscribeNotificationRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.notification.v1.SubscribeNotificationResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.notification.v1.SubscribeNotificationResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.notification.v1.SubscribeNotificationResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.notification.v1.SubscribeNotificationResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
notification: (f = msg.getNotification()) && proto.acompanha.notification.v1.Notification.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.notification.v1.SubscribeNotificationResponse}
 */
proto.acompanha.notification.v1.SubscribeNotificationResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.notification.v1.SubscribeNotificationResponse;
  return proto.acompanha.notification.v1.SubscribeNotificationResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.notification.v1.SubscribeNotificationResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.notification.v1.SubscribeNotificationResponse}
 */
proto.acompanha.notification.v1.SubscribeNotificationResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.acompanha.notification.v1.Notification;
      reader.readMessage(value,proto.acompanha.notification.v1.Notification.deserializeBinaryFromReader);
      msg.setNotification(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.notification.v1.SubscribeNotificationResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.notification.v1.SubscribeNotificationResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.notification.v1.SubscribeNotificationResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.notification.v1.SubscribeNotificationResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getNotification();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.acompanha.notification.v1.Notification.serializeBinaryToWriter
    );
  }
};


/**
 * optional Notification notification = 1;
 * @return {?proto.acompanha.notification.v1.Notification}
 */
proto.acompanha.notification.v1.SubscribeNotificationResponse.prototype.getNotification = function() {
  return /** @type{?proto.acompanha.notification.v1.Notification} */ (
    jspb.Message.getWrapperField(this, proto.acompanha.notification.v1.Notification, 1));
};


/**
 * @param {?proto.acompanha.notification.v1.Notification|undefined} value
 * @return {!proto.acompanha.notification.v1.SubscribeNotificationResponse} returns this
*/
proto.acompanha.notification.v1.SubscribeNotificationResponse.prototype.setNotification = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.notification.v1.SubscribeNotificationResponse} returns this
 */
proto.acompanha.notification.v1.SubscribeNotificationResponse.prototype.clearNotification = function() {
  return this.setNotification(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.notification.v1.SubscribeNotificationResponse.prototype.hasNotification = function() {
  return jspb.Message.getField(this, 1) != null;
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.acompanha.notification.v1.Notification.oneofGroups_ = [[1,2,3]];

/**
 * @enum {number}
 */
proto.acompanha.notification.v1.Notification.EventCase = {
  EVENT_NOT_SET: 0,
  ACK_EVENT: 1,
  PING_PONG_EVENT: 2,
  JOB_INTEGRATION_CHANGED_EVENT: 3
};

/**
 * @return {proto.acompanha.notification.v1.Notification.EventCase}
 */
proto.acompanha.notification.v1.Notification.prototype.getEventCase = function() {
  return /** @type {proto.acompanha.notification.v1.Notification.EventCase} */(jspb.Message.computeOneofCase(this, proto.acompanha.notification.v1.Notification.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.notification.v1.Notification.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.notification.v1.Notification.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.notification.v1.Notification} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.notification.v1.Notification.toObject = function(includeInstance, msg) {
  var f, obj = {
ackEvent: (f = msg.getAckEvent()) && proto.acompanha.notification.v1.AckEvent.toObject(includeInstance, f),
pingPongEvent: (f = msg.getPingPongEvent()) && proto.acompanha.notification.v1.PingPongEvent.toObject(includeInstance, f),
jobIntegrationChangedEvent: (f = msg.getJobIntegrationChangedEvent()) && proto.acompanha.notification.v1.JobIntegrationChangedEvent.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.notification.v1.Notification}
 */
proto.acompanha.notification.v1.Notification.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.notification.v1.Notification;
  return proto.acompanha.notification.v1.Notification.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.notification.v1.Notification} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.notification.v1.Notification}
 */
proto.acompanha.notification.v1.Notification.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.acompanha.notification.v1.AckEvent;
      reader.readMessage(value,proto.acompanha.notification.v1.AckEvent.deserializeBinaryFromReader);
      msg.setAckEvent(value);
      break;
    case 2:
      var value = new proto.acompanha.notification.v1.PingPongEvent;
      reader.readMessage(value,proto.acompanha.notification.v1.PingPongEvent.deserializeBinaryFromReader);
      msg.setPingPongEvent(value);
      break;
    case 3:
      var value = new proto.acompanha.notification.v1.JobIntegrationChangedEvent;
      reader.readMessage(value,proto.acompanha.notification.v1.JobIntegrationChangedEvent.deserializeBinaryFromReader);
      msg.setJobIntegrationChangedEvent(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.notification.v1.Notification.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.notification.v1.Notification.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.notification.v1.Notification} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.notification.v1.Notification.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAckEvent();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.acompanha.notification.v1.AckEvent.serializeBinaryToWriter
    );
  }
  f = message.getPingPongEvent();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.acompanha.notification.v1.PingPongEvent.serializeBinaryToWriter
    );
  }
  f = message.getJobIntegrationChangedEvent();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.acompanha.notification.v1.JobIntegrationChangedEvent.serializeBinaryToWriter
    );
  }
};


/**
 * optional AckEvent ack_event = 1;
 * @return {?proto.acompanha.notification.v1.AckEvent}
 */
proto.acompanha.notification.v1.Notification.prototype.getAckEvent = function() {
  return /** @type{?proto.acompanha.notification.v1.AckEvent} */ (
    jspb.Message.getWrapperField(this, proto.acompanha.notification.v1.AckEvent, 1));
};


/**
 * @param {?proto.acompanha.notification.v1.AckEvent|undefined} value
 * @return {!proto.acompanha.notification.v1.Notification} returns this
*/
proto.acompanha.notification.v1.Notification.prototype.setAckEvent = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto.acompanha.notification.v1.Notification.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.notification.v1.Notification} returns this
 */
proto.acompanha.notification.v1.Notification.prototype.clearAckEvent = function() {
  return this.setAckEvent(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.notification.v1.Notification.prototype.hasAckEvent = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional PingPongEvent ping_pong_event = 2;
 * @return {?proto.acompanha.notification.v1.PingPongEvent}
 */
proto.acompanha.notification.v1.Notification.prototype.getPingPongEvent = function() {
  return /** @type{?proto.acompanha.notification.v1.PingPongEvent} */ (
    jspb.Message.getWrapperField(this, proto.acompanha.notification.v1.PingPongEvent, 2));
};


/**
 * @param {?proto.acompanha.notification.v1.PingPongEvent|undefined} value
 * @return {!proto.acompanha.notification.v1.Notification} returns this
*/
proto.acompanha.notification.v1.Notification.prototype.setPingPongEvent = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto.acompanha.notification.v1.Notification.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.notification.v1.Notification} returns this
 */
proto.acompanha.notification.v1.Notification.prototype.clearPingPongEvent = function() {
  return this.setPingPongEvent(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.notification.v1.Notification.prototype.hasPingPongEvent = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional JobIntegrationChangedEvent job_integration_changed_event = 3;
 * @return {?proto.acompanha.notification.v1.JobIntegrationChangedEvent}
 */
proto.acompanha.notification.v1.Notification.prototype.getJobIntegrationChangedEvent = function() {
  return /** @type{?proto.acompanha.notification.v1.JobIntegrationChangedEvent} */ (
    jspb.Message.getWrapperField(this, proto.acompanha.notification.v1.JobIntegrationChangedEvent, 3));
};


/**
 * @param {?proto.acompanha.notification.v1.JobIntegrationChangedEvent|undefined} value
 * @return {!proto.acompanha.notification.v1.Notification} returns this
*/
proto.acompanha.notification.v1.Notification.prototype.setJobIntegrationChangedEvent = function(value) {
  return jspb.Message.setOneofWrapperField(this, 3, proto.acompanha.notification.v1.Notification.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.notification.v1.Notification} returns this
 */
proto.acompanha.notification.v1.Notification.prototype.clearJobIntegrationChangedEvent = function() {
  return this.setJobIntegrationChangedEvent(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.notification.v1.Notification.prototype.hasJobIntegrationChangedEvent = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.notification.v1.AckEvent.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.notification.v1.AckEvent.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.notification.v1.AckEvent} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.notification.v1.AckEvent.toObject = function(includeInstance, msg) {
  var f, obj = {
time: (f = msg.getTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.notification.v1.AckEvent}
 */
proto.acompanha.notification.v1.AckEvent.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.notification.v1.AckEvent;
  return proto.acompanha.notification.v1.AckEvent.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.notification.v1.AckEvent} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.notification.v1.AckEvent}
 */
proto.acompanha.notification.v1.AckEvent.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setTime(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.notification.v1.AckEvent.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.notification.v1.AckEvent.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.notification.v1.AckEvent} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.notification.v1.AckEvent.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTime();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional google.protobuf.Timestamp time = 1;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.acompanha.notification.v1.AckEvent.prototype.getTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 1));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.acompanha.notification.v1.AckEvent} returns this
*/
proto.acompanha.notification.v1.AckEvent.prototype.setTime = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.notification.v1.AckEvent} returns this
 */
proto.acompanha.notification.v1.AckEvent.prototype.clearTime = function() {
  return this.setTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.notification.v1.AckEvent.prototype.hasTime = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.notification.v1.PingPongEvent.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.notification.v1.PingPongEvent.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.notification.v1.PingPongEvent} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.notification.v1.PingPongEvent.toObject = function(includeInstance, msg) {
  var f, obj = {
time: (f = msg.getTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.notification.v1.PingPongEvent}
 */
proto.acompanha.notification.v1.PingPongEvent.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.notification.v1.PingPongEvent;
  return proto.acompanha.notification.v1.PingPongEvent.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.notification.v1.PingPongEvent} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.notification.v1.PingPongEvent}
 */
proto.acompanha.notification.v1.PingPongEvent.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setTime(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.notification.v1.PingPongEvent.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.notification.v1.PingPongEvent.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.notification.v1.PingPongEvent} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.notification.v1.PingPongEvent.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTime();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional google.protobuf.Timestamp time = 1;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.acompanha.notification.v1.PingPongEvent.prototype.getTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 1));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.acompanha.notification.v1.PingPongEvent} returns this
*/
proto.acompanha.notification.v1.PingPongEvent.prototype.setTime = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.notification.v1.PingPongEvent} returns this
 */
proto.acompanha.notification.v1.PingPongEvent.prototype.clearTime = function() {
  return this.setTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.notification.v1.PingPongEvent.prototype.hasTime = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.notification.v1.JobIntegrationChangedEvent.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.notification.v1.JobIntegrationChangedEvent.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.notification.v1.JobIntegrationChangedEvent} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.notification.v1.JobIntegrationChangedEvent.toObject = function(includeInstance, msg) {
  var f, obj = {
eventId: jspb.Message.getFieldWithDefault(msg, 1, ""),
printerUuid: jspb.Message.getFieldWithDefault(msg, 2, ""),
jobUuid: jspb.Message.getFieldWithDefault(msg, 3, ""),
action: jspb.Message.getFieldWithDefault(msg, 4, 0),
status: jspb.Message.getFieldWithDefault(msg, 5, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.notification.v1.JobIntegrationChangedEvent}
 */
proto.acompanha.notification.v1.JobIntegrationChangedEvent.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.notification.v1.JobIntegrationChangedEvent;
  return proto.acompanha.notification.v1.JobIntegrationChangedEvent.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.notification.v1.JobIntegrationChangedEvent} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.notification.v1.JobIntegrationChangedEvent}
 */
proto.acompanha.notification.v1.JobIntegrationChangedEvent.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setEventId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setPrinterUuid(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setJobUuid(value);
      break;
    case 4:
      var value = /** @type {!proto.acompanha.notification.v1.JobIntegrationAction} */ (reader.readEnum());
      msg.setAction(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.notification.v1.JobIntegrationChangedEvent.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.notification.v1.JobIntegrationChangedEvent.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.notification.v1.JobIntegrationChangedEvent} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.notification.v1.JobIntegrationChangedEvent.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEventId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPrinterUuid();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getJobUuid();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getAction();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
  f = message.getStatus();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
};


/**
 * optional string event_id = 1;
 * @return {string}
 */
proto.acompanha.notification.v1.JobIntegrationChangedEvent.prototype.getEventId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.notification.v1.JobIntegrationChangedEvent} returns this
 */
proto.acompanha.notification.v1.JobIntegrationChangedEvent.prototype.setEventId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string printer_uuid = 2;
 * @return {string}
 */
proto.acompanha.notification.v1.JobIntegrationChangedEvent.prototype.getPrinterUuid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.notification.v1.JobIntegrationChangedEvent} returns this
 */
proto.acompanha.notification.v1.JobIntegrationChangedEvent.prototype.setPrinterUuid = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string job_uuid = 3;
 * @return {string}
 */
proto.acompanha.notification.v1.JobIntegrationChangedEvent.prototype.getJobUuid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.notification.v1.JobIntegrationChangedEvent} returns this
 */
proto.acompanha.notification.v1.JobIntegrationChangedEvent.prototype.setJobUuid = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional JobIntegrationAction action = 4;
 * @return {!proto.acompanha.notification.v1.JobIntegrationAction}
 */
proto.acompanha.notification.v1.JobIntegrationChangedEvent.prototype.getAction = function() {
  return /** @type {!proto.acompanha.notification.v1.JobIntegrationAction} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.acompanha.notification.v1.JobIntegrationAction} value
 * @return {!proto.acompanha.notification.v1.JobIntegrationChangedEvent} returns this
 */
proto.acompanha.notification.v1.JobIntegrationChangedEvent.prototype.setAction = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};


/**
 * optional string status = 5;
 * @return {string}
 */
proto.acompanha.notification.v1.JobIntegrationChangedEvent.prototype.getStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.notification.v1.JobIntegrationChangedEvent} returns this
 */
proto.acompanha.notification.v1.JobIntegrationChangedEvent.prototype.setStatus = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * @enum {number}
 */
proto.acompanha.notification.v1.JobIntegrationAction = {
  JOB_INTEGRATION_ACTION_UNSPECIFIED: 0,
  JOB_INTEGRATION_ACTION_STARTED: 1,
  JOB_INTEGRATION_ACTION_FINISHED: 2
};

goog.object.extend(exports, proto.acompanha.notification.v1);
